module.exports = "/dist/media/flags.9c74e172.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/images/flags.png
// module id = 886
// module chunks = 0